import { render } from "./TimelineItem.vue?vue&type=template&id=606fe585&scoped=true"
import script from "./TimelineItem.vue?vue&type=script&lang=js"
export * from "./TimelineItem.vue?vue&type=script&lang=js"

import "./TimelineItem.vue?vue&type=style&index=0&id=606fe585&scoped=true&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606fe585"]])

export default __exports__